export default {
  header: 'Choose Menu',
  open_now: 'Open Now',
};
